import '@babel/polyfill'
import 'nodelist-foreach-polyfill'
import Swiper from 'swiper'

const selectors = {
  el: '.js-customersCarousel',
  pagination: '.c-customers__pagination',
  thumb: '.js-customersCarousel .c-customer__thumb',
  bullet: '.swiper-pagination-bullet'
}

export default () => {
  window.customersCarousel = new Swiper(selectors.el, {
    effect: 'fade',
    slidesPerView: 1,
    pagination: {
      el: selectors.pagination,
      clickable: true
    },
    on: {
      paginationRender: function (paginationEl) {
        const thumbs = document.querySelectorAll(selectors.thumb)
        const bullets = paginationEl.querySelectorAll(selectors.bullet)

        thumbs.forEach((thumb, index) => {
          const img = document.createElement('img')
          img.setAttribute('src', thumbs[index].getAttribute('data-src-thumb'))
          bullets[index].appendChild(img)
        })
      }
    }
  })
}
